export const categories = [
  {
    type: "movie",
    name: "电影",
    shortName: "热门电影",
    description: "最新热门电影，涵盖动作、科幻、悬疑、爱情等多种类型，一键畅享高清片源。",
    icon: "ri-film-line",
  },
  {
    type: "tv",
    name: "电视剧",
    shortName: "火爆剧集",
    description: "火爆电视剧持续更新，国产、美剧、日韩一应俱全，追剧不用等。",
    icon: "ri-tv-2-line",
  },
  {
    type: "variety",
    name: "综艺",
    shortName: "热门综艺",
    description: "热门综艺精彩不断，真人秀、音乐、美食、脱口秀，快乐随心看。",
    icon: "ri-mic-line",
  },
];